<template>
  <div class="redeem-box" v-loading="loading">
    <div class="shop-module">
      <div class="shop-module-box" v-for="(item, index) in moduleList" :key="item.id" :class="moduleIndex === index ? 'module-active' : ''" @click="changeModule(index)">
        {{ item.name }}
      </div>
    </div>
    <div class="shop-area" v-if="moduleIndex === 0">
      <div class="shop-item" v-for="item in shopList" :key="item.id">
        <div class="shop-img" 
          :style="{
            'background': `url(${item.productImage})`
          }"
        ></div>
        <div class="title">{{ item.productName }}</div>
        <div class="depict-box">
          <div>
            <div class="d_r">兑换</div>
            <span class="d_l">
              <strong>{{ item.productPoint }}</strong>
              积分
            </span>
          </div>
          <div class="btn-exchange" @click="exchange(item)">立即兑换</div>
        </div>
      </div>
    </div>
    <div class="shop-area" v-else>
      <div class="shop-item" v-for="item in shopList" :key="item.id">
        <div class="shop-img" 
          :style="{
            'background': `url(${item.productImage})`
          }"
        ></div>
        <div v-if="item.productImageList && item.productImageList !== ''" class="show-item-question" @click="showPrize(item)"></div>
        <div class="title">{{ item.productName }} <span v-if="!item.productImageList && item.totalInventory && item.productInventory">({{ item.totalInventory-item.productInventory }}/{{ item.totalInventory }})</span></div>
        <div class="depict-box">
          <div>
            <div class="d_r">兑换</div>
            <span class="d_l">
              <strong>{{ item.productPoint }}</strong>
              积分
            </span>
          </div>
          <div class="btn-exchange" @click="exchangeSurr(item)">立即兑换</div>
        </div>
      </div>
    </div>
    <div class="mask" v-if="showPop">
      <div class="exchange-pop" v-if="showExchange">
        <div class="pop-title">
          <div class="pop-tip">确认兑换</div>
          <div class="pop-close" @click="closePop">X</div>
        </div>
        <div class="pop-detail">
          <div class="detail-img">
            <div class="show-img" :style="{
              'background': `url(${productInfo.productImage})`,
            }"></div>
          </div>
          <div class="detail-full">
            <div class="full-msg">{{ productInfo.productName }}</div>
            <div class="full-worth">消耗<p class="full-value"> {{ productInfo.productPoint }} </p>积分</div>
            <div class="full-btn" @click="confirmExchange">立即兑换</div>
          </div>
        </div>
        <div class="pop-synopsis">
          <p>商品简介</p>
          <span>{{ productInfo.productDesc }}</span>
        </div>
        <div class="pop-illustrate">
          <div class="pop-describe">兑换描述</div>
          <p v-html="productInfo.exchangeDesc.replace(/\\n/g,'<br>').replace(/\\/g,'')"></p>
        </div>
      </div>
      <div class="user-pop" v-if="showUser">
        <div class="user-title">角色信息确认</div>
        <div class="user-protocol">
          <el-checkbox type="checkbox" v-model="isCheck" @change="switchCheck" />    我同意“本活动获取并存储到的游戏区服和角色相关信息，仅用于该活动的抽奖、领取、发货、签到等操作”
        </div>
        <div class="user-select">
          <el-select class="user-select-option" :disabled="!isCheck" v-model="selectServer" placeholder="请选择服务器" @change="checkServer">
            <el-option
              v-for="item in serverList"
              :key="item.gameZoneId"
              :label="item.zoneName"
              :value="item.gameZoneId">
            </el-option>
          </el-select>
          <el-input
            class="user-select-option"
            placeholder="请选择角色"
            v-model="selectUser"
            :disabled="true">
          </el-input>
        </div>
        <div class="user-btnbox">
          <div class="user-btn confirm" @click="confirm">确定</div>
          <div class="user-btn" @click="cancel">取消</div>
        </div>
      </div>
      <div class="prize-pop" v-if="showLuckybag">
        <div class="prize-title-box">
          <div class="prize-title-msg">周年福袋</div>
          <div class="prize-title-close" @click="closePrize">X</div>
        </div>
        <div class="prize-exchange-msg">
            <p>兑换数量上限</p>
            <span>({{ prizeTotalInventory-prizeInventory }}/{{ prizeTotalInventory }})</span>
          </div>
        <div class="prize-common" v-if="commonList.length !== 0">
          <div class="prize-common-show" v-for="item in commonList" :key="item.id" :style="{'background': `url(${item.productImage})`, width: prizeBoxWidth + '%'}">
          </div>
        </div>
        <div class="prize-pop-msg">
          {{ prizePopMsg }}
        </div>
      </div>
      <div class="exchange-surr-pop" v-if="showExchangeSurr">
        <div class="exchange-surr-title">
          <div class="exchang-surr-close" @click="closeExchangeSurr()">X</div>
        </div>
        <div class="exchang-surr-common">是否确认消耗{{ prizeConsume }}积分兑换{{ prizeProductName }}物品</div>
        <div class="exchang-surr-btn" @click="confirm()">确认</div>
      </div>
      <div class="address-pop" v-if="showAddress">
        <div class="address-title">
          <div class="address-title-msg">兑换成功，请填写邮寄地址</div>
          <div class="address-title-close" @click="closeAddress">X</div>
        </div>
        <div class="address-common">
          <div class="address-input-box">
            <label for="">联系人：</label>
            <input type="text" v-model="addressInfo.contacts" class="address-input-user">
          </div>
          <div class="address-input-box">
            <label for="">联系电话：</label>
            <input type="text" v-model="addressInfo.phone" class="address-input-user" maxlength="11">
          </div>
          <div class="address-input-box">
            <label for="">详细地址：</label>
            <textarea type="text" v-model="addressInfo.address" class="address-input-textarea"></textarea>
          </div>
        </div>
        <div class="address-btn" @click="bindAddress">
          提交
        </div>
      </div>
      <div class="common-pop" v-if="showCommon">
        <div class="common-title">
          <div class="common-title-close" @click="closeCommon">X</div>
        </div>
        <div class="common-box">{{ commonMsg }}</div>
        <div class="common-btn" @click="closeCommon">返回</div>
      </div>
    </div>
    <el-pagination
      v-if="shopList.length !== 0"
      @current-change="handleCurrentChange"
      background
      :page-size="12"
      :current-page.sync="currentPage"
      layout="total, prev, pager, next"
      :total="totalPage"
    >
    </el-pagination>
  </div>
</template>

<script>
import { getUserServer, getUserRole, getShopList, exchangeShops, bindUserAddress } from '@/api/points.js'
import { mapState } from 'vuex'
export default {
  name: 'redeem',
  data() {
    return {
      totalPage: 0,
      currentPage: 1,
      shopList: [],
      showPop: false,
      showExchange: false,
      showExchangeSurr: false,
      showUser: false,
      isCheck: false,
      serverList: [],
      selectUser: '',
      selectUserId: '',
      selectServer: '',
      productInfo: '',
      loading: false,
      isConfirm: false,
      moduleList: [
        {
          name: '道具兑换',
          id: 1
        },
        {
          name: '周边兑换',
          id: 2
        },
      ],
      commonList: [
        {
          productImage: 'https://tg.wx7road.com/ddtdmx/img/goods_display/mjshz.png',
          id: 0
        },
        {
          productImage: 'https://tg.wx7road.com/ddtdmx/img/goods_display/sltqg.png',
          id: 2
        },
        {
          productImage: 'https://tg.wx7road.com/ddtdmx/img/goods_display/jbnchk.png',
          id: 1
        }
      ],
      moduleIndex: 0,
      showLuckybag: false,
      showAddress: false,
      showCommon: false,
      prizePopMsg: '',
      prizeConsume: '',
      prizeProductName: '',
      prizeInventory: 0,
      prizeTotalInventory: 0,
      addressInfo: {
        bindEvidence: '',
        transactionId: '',
        contacts: '',
        phone: '',
        address: '',
      },
      commonMsg: '积分余额不足'
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    }),
    prizeBoxWidth() {
      return 100/this.commonList.length
    }
  },
  mounted() {
    this.getExchangeList(this.currentPage)
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val
      this.getExchangeList(val)
    },
    exchange(data) {
      if (Number(this.userInfo.userPoint) < Number(data.productPoint)) {
        this.$message({
          type: 'error',
          message: '积分余额不足'
        })
        return false
      }
      this.showPop = true
      this.showExchange = true
      this.productInfo = data
    },
    exchangeSurr(data) {
      this.showPop = true
      this.showExchangeSurr = true
      this.prizeConsume = data.productPoint
      this.prizeProductName = data.productName
      this.productInfo = data
    },
    closeExchangeSurr() {
      this.showPop = false
      this.showExchangeSurr = false
    },
    closePop() {
      this.showPop = false
      this.showExchange = false
    },
    confirmExchange() {
      this.serverList = []
      getUserServer().then((res) => {
        if (res && res.code === 0) {
          this.showExchange = false
          this.showUser = true
          this.serverList = res.data
        } else {
          this.showPop = false
          this.showExchange = false
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      }).catch((err) => {
        this.$message({
          type: 'error',
          message: err.msg
        })
      })
    },
    checkServer(val) {
      if (val) {
        this.isConfirm = false
        getUserRole({
          gameZoneId: val
        }).then((res) => {
          if (res && res.code === 0) {
            if (res.data.length !== 0) {
              this.selectUser = res.data[0].roleName
              this.selectUserId = res.data[0].roleId
            } else {
              this.selectUser = ''
              this.selectUserId = ''
            }
            this.isConfirm = true
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.msg
          })
        })
      }
    },
    cancel() {
      this.showPop = false
      this.showUser = false
      this.selectServer = ''
      this.selectUser = ''
      this.isCheck = false
    },
    confirm() {
      if (this.moduleIndex === 0 && this.selectServer === '') {
        this.$message({
          type: 'error',
          message: '请先选择服务器'
        })
        return false
      }
      if (this.moduleIndex === 0 && this.selectUser === '') {
        this.$message({
          type: 'error',
          message: '所选服务器没有角色'
        })
        return false
      }
      if (this.moduleIndex === 0 && !this.isConfirm) {
        this.$message({
          type: 'error',
          message: '正在获取角色信息，请稍等'
        })
        return false
      }
      if (this.productInfo.productInventory && Number(this.productInfo.productInventory) === 0) {
        this.$message({
          type: 'error',
          message: '已达到兑换上限'
        })
        return false
      }
      this.loading = true
      exchangeShops({
        gameZoneId: this.selectServer,
        roleId: this.selectUserId,
        productId: this.productInfo.productId,
        productType: this.moduleList[this.moduleIndex].id
      }).then((res) => {
        this.loading = false
        if (res && res.code === 0) {
          if (Number(this.moduleIndex) === 1) {
            this.showPop = true
            this.showAddress = true
            this.addressInfo.bindEvidence = res.data.bindEvidence
            this.addressInfo.transactionId = res.data.transactionId
            this.$store.dispatch('getUserInfo')
            return
          } else {
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.$store.dispatch('getUserInfo')
          }
        } else {
          // this.showPop = true
          // this.showCommon = true
          // this.commonMsg = res.msg
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      }).catch((err) => {
        this.loading = false
        this.$message({
          type: 'error',
          message: err.msg
        })
      })
      this.showPop = false
      this.showUser = false
      this.showExchangeSurr = false
      this.selectServer = ''
      this.selectUser = ''
      this.isCheck = false
      this.isConfirm = false
    },
    switchCheck() {
      if (!this.isCheck) {
        this.selectServer = ''
      }
    },
    getExchangeList(index) {
      this.loading = true
      getShopList({
        pageNum: index,
        pageSize: 12,
        productType: this.moduleList[this.moduleIndex].id
      }).then((res) => {
        if (res && res.code === 0) {
          this.shopList = res.data.content
          this.totalPage = res.data.totalCount
        }
        this.loading = false
      })
    },
    changeModule(index) {
      this.moduleIndex = index
      this.getExchangeList(this.currentPage)
    },
    showPrize(data) {
      this.commonList = []
      let popPrizeList = data.productImageList.split(',')
      popPrizeList.map((list, index) => {
        this.commonList.push({
          productImage: list,
          id: index
        })
      })
      this.prizePopMsg = data.productDesc
      this.prizeInventory = data.productInventory
      this.prizeTotalInventory = data.totalInventory
      this.showPop = true
      this.showLuckybag = true
    },
    closePrize() {
      this.showPop = false
      this.showLuckybag = false
    },
    closeAddress() {
      this.showPop = false
      this.showAddress = false
      this.addressInfo.address = ''
      this.addressInfo.contacts = ''
      this.addressInfo.phone = ''
      this.addressInfo.bindEvidence = ''
      this.addressInfo.transactionId = ''
    },
    bindAddress() {
      if (!/^1[0-9]{10}/.test(this.addressInfo.phone)) {
        this.$message({
          type: 'error',
          message: '请正确填写手机号码'
        })
        return false
      }
      if (!/^[\u4e00-\u9fa5]+$/.test(this.addressInfo.contacts)) {
        this.$message({
          type: 'error',
          message: '请正确填写姓名'
        })
        return false
      }
      if (this.addressInfo.address === '') {
        this.$message({
          type: 'error',
          message: '请填写详细地址'
        })
        return false
      }
      bindUserAddress(this.addressInfo).then((res) => {
        if (res && res.code === 0) {
          this.showPop = false
          this.showAddress = false
          this.addressInfo.address = ''
          this.addressInfo.contacts = ''
          this.addressInfo.phone = ''
          this.addressInfo.bindEvidence = ''
          this.addressInfo.transactionId = ''
          this.$message({
            type: 'success',
            message: '填写成功'
          })
          this.getExchangeList()
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      }).catch((err) => {
        this.$message({
          type: 'error',
          message: err.msg
        })
      })
    },
    closeCommon() {
      this.commonMsg = ''
      this.showPop = false
      this.showCommon = false
    }
  },
};
</script>

<style lang="less" scoped>
.redeem-box {
  width: 100%;
  height: 100%;
  padding: 10px 5px 0;
  box-sizing: border-box;
  .shop-module {
    display: flex;
    width: 205px;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
    .shop-module-box {
      font-size: 16px;
      color: #363636;
      padding: 1px 15px;
      box-sizing: border-box;
      border: 1px solid #363636;
      cursor: pointer;
    }
    .module-active {
      border: 1px solid #ed9500;
      color: #ed9500;
    }
  }
  .shop-area {
    width: 100%;
    height: 385px;
    background-color: #f5f5f5;
    margin-bottom: 30px;
    padding: 6px 4px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    overflow-y: scroll;
    .shop-item {
      width: 240px;
      height: 180px;
      background-color: #fff;
      margin-top: 7px;
      margin-right: 6px;
      margin-left: 4px;
      margin-bottom: 8px;
      font-size: 12px;
      padding-top: 10px;
      box-sizing: border-box;
      position: relative;
      .shop-img {
        width: 100%;
        height: 94px;
        // background: url("https://webpic.my4399.com/web/2309/011752319669.jpg");
        background-repeat: no-repeat !important;
        background-size: contain !important;
        background-position: center !important;
        display: block;
        margin: 0 auto;
        cursor: pointer;
      }
      .show-item-question {
        width: 33px;
        height: 33px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background: url("~@/assets/images/question-mark.png");
        z-index: 100;
        position: absolute;
        left: 50%;
        top: 30%;
        transform: translateX(-50%);
        cursor: pointer;
      }
      .title {
        height: 26px;
        line-height: 26px;
        padding: 0 10px 1px 10px;
        box-sizing: border-box;
        color: #565656;
        span {
          width: 100%;
          text-align: right;
          color: #e3721f;
          font-size: 12px;
          padding-right: 8px;
          box-sizing: border-box;
        }
      }
      .depict-box {
        width: 100%;
        height: auto;
        padding: 0 10px;
        box-sizing: border-box;
        color: #888;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .d_r {
          padding: 2px 5px;
          text-align: center;
          box-sizing: border-box;
          border: 1px solid #ff5d13;
          color: #ff5d13;
          margin-bottom: 4px;
        }
        .d_l {
          strong {
            color: #ff5d13;
            font-size: 14px;
          } 
        }
        .btn-exchange {
          width: 73px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          background-color: #ec6c04;
          color: #fff;
          cursor: pointer;
          use-select: none;
        }
      }
    }
  }
  /deep/ .el-pagination__total {
    border: 1px solid #ed9500;
    padding: 0 5px;
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active  {
    background-color: #ed9500;
    color: #fff;
    &:hover {
      color: #fff;
    }
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #ed9500;
  }
  /deep/ .el-pagination.is-background .el-pager li {
    background-color: #fff;
    border: 1px solid #ed9500;
    color: #ed9500;
  }
  .mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 999;
  }
  .exchange-pop {
    position: absolute;
    left: 50%;
    top: 25%;
    transform: translateX(-50%);
    border: 1px solid #c9bdbd;
    width: 630px;
    height: 475px;
    background: #fff;
    padding: 15px 15px;
    box-sizing: border-box;
    animation: showDialog 0.5s;
    animation-timing-function: cubic-bezier(0.6,0,0.4,1);
    .pop-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .pop-tip {
        font-size: 24px;
        color: #ec6c04;
      }
      .pop-close {
        color: #c2c2c2;
        font-size: 25px;
        cursor: pointer;
      }
    }
    .pop-detail {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .detail-img {
        width: 312px;
        height: 215px;
        .show-img {
          width: 312px;
          height: 215px;
          // background: url("https://webpic.my4399.com/web/2309/011752319669.jpg");
          background-repeat: no-repeat !important;
          background-size: contain !important;
          background-position: center !important;
        }
      }
      .detail-full {
        flex: 1;
        margin-left: 20px;
        .full-msg {
          font-size: 18px;
          color: #595d64;
          margin-bottom: 10px;
        }
        .full-worth {
          font-size: 14px;
          color: #595d64;
          margin-bottom: 10px;
          p {
            display: inline;
            font-size: 28px;
            color: #f45959;
          }
        }
        .full-btn {
          width: 95px;
          background: #ec6c04;
          color: #fff;
          padding: 10px 5px;
          box-sizing: border-box;
          cursor: pointer;
          text-align: center;
          margin-top: 25px;
        }
      }
    }
    .pop-synopsis {
      width: 100%;
      margin-top: 5px;
      padding-bottom: 22px;
      border-bottom: 1px solid #dddddd;
      p {
        font-size: 16px;
        color: #61646b;
        margin: 0 auto;
      }
      span {
        display: block;
        font-size: 14px;
        color: #595d64;
        margin-top: 5px;
      }
    }
    .pop-illustrate {
      margin-top: 10px;
      .pop-describe {
        font-size: 16px;
        color: #61646b;
        margin-bottom: 5px;
      }
      p {
        margin: 0 auto;
        font-size: 14px;
        color: #595d64;
      }
    }
  }
  .user-pop {
    width: 545px;
    height: 310px;
    position: absolute;
    left: 50%;
    top: 25%;
    transform: translateX(-50%);
    background: #fff;
    animation: showDialog 0.5s;
    animation-timing-function: cubic-bezier(0.6,0,0.4,1);
    .user-title {
      width: 100%;
      background: #ec6c04;
      color: #fff;
      padding: 15px 0 15px 20px;
      box-sizing: border-box;
      font-size: 20px;
      font-weight: bold;
    }
    .user-protocol {
      width: 100%;
      padding: 15px 10px 0px 10px;
      box-sizing: border-box;
      /deep/.el-checkbox__inner {
        width: 18px;
        height: 18px;
        border-radius: 50% !important;
        margin-top: -1px;
        margin-right: 5px;
        &::after {
          height: 11px !important;
          left: 5px !important;
          width: 5px !important;
        }
      }
    }
    .user-select {
      width: 100%;
      padding: 0px 10px 15px 10px;
      box-sizing: border-box;
      overflow: hidden;
      .user-select-option {
        width: 100%;
        margin-top: 18px;
      }
    }
    .user-btnbox {
      width: 100%;
      padding: 6px 10px 1px 10px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      .user-btn {
        width: 235px;
        height: 50px;
        font-size: 20px;
        font-weight: bold;
        color: #fff;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
        background: #999999;
      }
      .confirm {
        background: #ec6c04;
      }
    }
  }
  .prize-pop {
    width: 280px;
    height: 210px;
    position: absolute;
    left: 50%;
    top: 25%;
    transform: translateX(-50%);
    background: #fff;
    animation: showDialog 0.5s;
    animation-timing-function: cubic-bezier(0.6,0,0.4,1);
    .prize-title-box {
      display: flex;
      justify-content: flex-start;
      width: 100%;
      height: 30px;
      border-bottom: 1px solid #dddddd;
      align-items: center;
      .prize-title-msg {
        flex: 1;
        height: 100%;
        line-height: 30px;
        font-size: 14px;
        color: #ec6c04;
        text-align: center;
      }
      .prize-title-close {
        font-size: 16px;
        color: #c5c5c5;
        font-weight: bold;
        cursor: pointer;
        width: 18px;
        height: 18px;
      }
    }
    .prize-exchange-msg {
      width: 100%;
      text-align: right;
      overflow: hidden;
      margin-top: 5px;
      p {
        width: 100%;
        text-align: right;
        font-size: 12px;
        margin: 0;
        padding-right: 8px;
        box-sizing: border-box;
      }
      span {
        display: block;
        width: 100%;
        text-align: right;
        color: #e3721f;
        font-size: 12px;
        padding-right: 8px;
        box-sizing: border-box;
      }
    }
    .prize-common {
      display: flex;
      width: 100%;
      box-sizing: border-box;
      padding: 0 15px;
      justify-content: space-between;
      align-items: center;
      height: 90px;
      .prize-common-show {
        height: 90px;
        background-repeat: no-repeat !important;
        background-size: contain !important;
        background-position: center !important;
        display: block;
        margin: 0 auto;
        cursor: pointer;
      }
    }
    .prize-pop-msg {
      width: 260px;
      margin: 0 auto;
      margin-top: 10px;
      font-size: 12px;
      color: #1e1e1e;
      text-align: center;
    }
  }
  .exchange-surr-pop {
    width: 435px;
    height: 230px;
    background: #fff;
    position: absolute;
    left: 50%;
    top: 25%;
    transform: translateX(-50%);
    background: #fff;
    animation: showDialog 0.5s;
    animation-timing-function: cubic-bezier(0.6,0,0.4,1);
    .exchange-surr-title {
      width: 100%;
      height: 50px;
      background: #ec6c04;
      padding-right: 15px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .exchang-surr-close {
        font-size: 16px;
        font-weight: bold;
        color: #fff;
        cursor: pointer;
      }
    }
    .exchang-surr-common {
      width: 320px;
      height: 58px;
      text-overflow: ellipsis;
      margin: 0 auto;
      font-size: 22px;
      color: #6a6a6a;
      text-align: center;
      margin-top: 30px;
      margin-bottom: 25px;
    }
    .exchang-surr-btn {
      margin: 0 auto;
      width: 225px;
      height: 50px;
      border-radius: 5px;
      background: #ec6c04;
      text-align: center;
      line-height: 50px;
      font-size: 20px;
      color: #fff;
      font-weight: bold;
      cursor: pointer;
    }
  }
  .address-pop {
    width: 435px;
    height: 310px;
    position: absolute;
    left: 50%;
    top: 25%;
    transform: translateX(-50%);
    background-color: #fff;
    animation: showDialog 0.5s;
    animation-timing-function: cubic-bezier(0.6,0,0.4,1);
    .address-title {
      display: flex;
      box-sizing: border-box;
      justify-content: flex-start;
      align-items: center;
      height: 50px;
      width: 100%;
      background: #ec6c04;
      padding-right: 13px;
      .address-title-msg {
        font-size: 20px;
        color: #fff;
        font-weight: bold;
        text-align: center;
        flex: 1;
      }
      .address-title-close {
        font-size: 24px;
        font-weight: bold;
        color: #fff;
        cursor: pointer;
        width: 22px;
        height: 22px;
      }
    }
    .address-common {
      overflow: hidden;
      width: 280px;
      margin: 0 auto;
      margin-top: 5px;
      .address-input-box {
        display: flex;
        margin-top: 12px;
        align-items: flex-start;
        justify-content: flex-start;
        label {
          width: 90px;
          text-align: left;
          height: 30px;
          line-height: 30px;
          font-size: 18px;
          color: #6a6a6a;
        }
        .address-input-user {
          height: 30px;
          line-height: 30px;
          // margin-left: 15px;
          border: 1px solid #ececec;
          box-sizing: border-box;
          width: 190px;
          padding: 5px 0;
          padding-left: 15px;
          font-size: 18px;
          outline: none;
          font-family: "微软雅黑";
        }
        .address-input-textarea {
          border: 1px solid #ececec;
          padding: 5px 0;
          padding-left: 15px;
          box-sizing: border-box;
          width: 190px;
          height: 65px;
          font-size: 18px;
          outline: none;
          font-family: "微软雅黑";
          resize: none;
        }
      }
    }
    .address-btn {
      width: 235px;
      height: 50px;
      background: #ec6c04;
      color: #fff;
      font-size: 22px;
      font-weight: bold;
      margin: 0 auto;
      margin-top: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }
  .common-pop {
    width: 435px;
    height: 230px;
    position: absolute;
    left: 50%;
    top: 25%;
    transform: translateX(-50%);
    background-color: #fff;
    animation: showDialog 0.5s;
    animation-timing-function: cubic-bezier(0.6,0,0.4,1);
    overflow: hidden;
    .common-title {
      width: 100%;
      height: 50px;
      background: #ec6c04;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 12px;
      box-sizing: border-box;
      .common-title-close {
        font-size: 26px;
        color: #fff;
        font-weight: bold;
        cursor: pointer;
      }
    }
    .common-box {
      width: 90%;
      margin: 0 auto;
      margin-top: 25px;
      font-size: 24px;
      text-align: center;
      color: #6a6a6a;
    }
    .common-btn {
      width: 230px;
      height: 45px;
      cursor: pointer;
      background: #ec6c04;
      text-align: center;
      line-height: 45px;
      color: #fff;
      border-radius: 5px;
      font-size: 22px;
      font-weight: bold;
      position: absolute;
      left: 50%;
      bottom: 10%;
      transform: translateX(-50%);
    }
  }
}
@keyframes showDialog {
  0% {
    opacity: 0;
    left: 50%;
    transform: scale3d(0, 0, 0), translateX(-50%);
  }
  100% {
    opacity: 1;
    left: 50%;
    transform: scale3d(1, 1, 1), translateX(-50%);
  }
}
</style>